import toLower from 'lodash/toLower';
export const _toLower = toLower;
